import ExtraMaterial from 'services/course/models/extra-material-interface';

import ExtraMaterialCard from './components/ExtraMaterialCard';

import { SupportMaterialWrapper } from './style';

interface IMaterialCourse {
  materialCourse: Array<ExtraMaterial>;
}

const SupportMaterial: React.FC<IMaterialCourse> = ({ materialCourse }) => {
  return (
    <SupportMaterialWrapper>
      <h4>Materiais de apoio</h4>

      {materialCourse && materialCourse.length ? (
        <div className="material-wrapper">
          {materialCourse.map((extraMaterial: ExtraMaterial, index: number) => (
            <ExtraMaterialCard key={index} materialCourse={extraMaterial} />
          ))}
        </div>
      ) : (
        <h4>Nenhum material disponível</h4>
      )}
    </SupportMaterialWrapper>
  );
};

export default SupportMaterial;
